<template>
  <div class="project pa-3">
    <div v-if="hasAccessToProjectManagement">
      <project-dashboard v-if="showProjectDashboard" />

      <project-profile v-if="showProjectProfile" />

      <project-modal />
    </div>

    <div v-else>
      <access-denied-card
        title="Access Denied"
        message="You don't have permission to view projects."
        details="Project access is restricted to authorized team members. If you believe you should have access to this feature, please contact your administrator."
      />
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

import { makeProject } from '@/internal/store/utils/project'

const { mapGetters: mapAuthGetters } = createNamespacedHelpers('auth')
const { mapState: mapInternalState } = createNamespacedHelpers('internal')

export default {
  name: 'Project',

  components: {
    AccessDeniedCard: () => import('../components/AccessDeniedCard'),
    ProjectDashboard: () => import('../components/Projects.vue'),
    ProjectModal: () => import('../components/ProjectModal'),
    ProjectProfile: () => import('../components/Project.vue'),
  },

  computed: {
    ...mapAuthGetters([
      'hasAccessToProjectManagement',
    ]),
    ...mapInternalState([
      'isProjectModalVisible',
    ]),

    showProjectDashboard() {
      const { reportId } = this.$route.params

      return !reportId || reportId.length === 0 || reportId === 'dashboard'
    },

    showProjectProfile() {
      const { reportId } = this.$route.params
      return reportId && reportId.length > 0 && reportId !== 'dashboard'
    },
  },

  methods: {
    showFormProject() {
      const action = 'create'
      const formData = makeProject({})

      this.$store.dispatch('internal/showFormProject', { action, formData })
    },
  },
}
</script>
